import { prefixObjectValues } from '../utils';

const authentication = {
  signInButton: 'sign-in-button',
  signUpButton: 'sign-up-button',
  signUpEmployerButton: 'sign-up-employer-button',
};
export default prefixObjectValues(authentication, 'authentication');
